/* unplugin-vue-components disabled */import { render } from "./MyImage.vue?vue&type=template&id=13442017&scoped=true"
import script from "./MyImage.vue?vue&type=script&lang=js"
export * from "./MyImage.vue?vue&type=script&lang=js"

import "./MyImage.vue?vue&type=style&index=0&id=13442017&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13442017"]])

export default __exports__